module.exports = __webpack_public_path__ + "static/img/qr_junior_teacher_logo_500.f24ce2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_junior_teacher_logo_500.png
// module id = 1qnf
// module chunks = 1